var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "540px",
        "append-to-body": "",
        "before-close": _vm.handleResetForm,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.dialogVisible && _vm.formValidate
        ? _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                model: _vm.formValidate,
                rules: _vm.rules,
                "label-width": "80px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "配送人员：", prop: "personnelName" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: 16,
                      placeholder: "请输入配送人员姓名",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formValidate.personnelName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "personnelName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.personnelName",
                    },
                  }),
                  _c("div", { staticClass: "from-tips mb5" }, [
                    _vm._v(
                      "订单采用商家直接配送的方式发货，根据配送人员的姓名来进行选择。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话：", prop: "personnelPhone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入配送人员联系电话" },
                    model: {
                      value: _vm.formValidate.personnelPhone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "personnelPhone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.personnelPhone",
                    },
                  }),
                  _c("div", { staticClass: "from-tips mb5" }, [
                    _vm._v(
                      "订单采用商家直接配送的方式发货后，用户可通过手机号码联系该配送员。"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序：" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 99,
                      step: 1,
                      "step-strictly": "",
                      placeholder: "请输入排序",
                      label: "排序",
                    },
                    model: {
                      value: _vm.formValidate.sort,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "sort",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.sort",
                    },
                  }),
                  _c("div", { staticClass: "from-tips mb5" }, [
                    _vm._v("请输入0~99的数字，数字越大越靠前。"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleResetForm } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingBtn },
              on: { click: _vm.handleSure },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }